var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"App"}},[_c('Header'),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[_c('router-view',{key:_vm.$route.name})],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }